import dynamic from 'next/dynamic'
import Head from 'next/head'

const Content = dynamic(() => import('../toyota/components/publication/publicationContents'))

const ToyotaLayout = props => {
  return (
    <>
      <Head>
        {/* eslint-disable-next-line @next/next/no-css-tags -- CSS targets class names in externally-imported HTML content, CSS Modules cannot be used */}
        <link rel="stylesheet" href="/styles/tme_publications.css" />
      </Head>
      <Content {...props} />
    </>
  )
}

export default ToyotaLayout
